import { TableHeadersType } from "./tableHeadersType";

export const CHECK_IN_SCHEDULE_HEADERS: TableHeadersType[] = [
  {
    label: "Employee ID",
    value: "employee_iD",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Name",
    value: "name",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Job Location",
    value: "job_location",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "check in date",
    value: "last_check_in_date",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "reporting manager",
    value: "reporting_manager",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Employment status",
    value: "employment_status",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "comments",
    value: "comments",
    checked: true,
    defaultChecked: true,
  },

  {
    label: "comments added by",
    value: "comments_added_by",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];

export const MY_PERFORMANCE_EVALAUTION_HEADERS: TableHeadersType[] = [
  {
    label: "Title",
    value: "title",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Hours",
    value: "hours",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Rating",
    value: "rating",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Feedback",
    value: "feedback",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Manager",
    value: "manager",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "File Attachment",
    value: "file_attachment",
    checked: true,
    defaultChecked: true,
  },
 
  {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];
export const ALL_PERFORMANCE_EVALAUTION_HEADERS: TableHeadersType[] = [
  {
    label: "Employee Name",
    value: "first_name",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Title",
    value: "title",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Hours",
    value: "hours",
    checked: true,
    defaultChecked: true,
  },
 
  {
    label: "Date Range",
    value: "end_date",
    checked: true,
    defaultChecked: true,
  },
 
  {
    label: "File Attachment",
    value: "file_attachment",
    checked: true,
    defaultChecked: true,
  },
 
  {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];
export const performanceEvaluationRatingDropdown=[
    {
      value: "1",
      label: "1 - Outstanding performer.",
    },
    {
      value: "2",
      label: "2 - Exceeding expectations.",
    },
    {
      value: "3",
      label: "3- Meeting all expectations.",
    },
    {
      value: "4",
      label: "4 - Not meeting expectations.",
    },
    {
      value: "5",
      label: "5 - Issues in work performance and have to let go.",
    },
  
]

export const HRMS_PERFORMANCE_EVALAUTION_HEADERS: TableHeadersType[] = [
  {
    label: "Employee Id",
    value: "employee_id",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Employee Name",
    value: "first_name",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "PE Title",
    value: "title",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Total Hours Spent",
    value: "hours",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Manager",
    value: "manager",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Date Range",
    value: "end_date",
    checked: true,
    defaultChecked: true,
  },
 
  {
    label: "File Attachment",
    value: "file_attachment",
    checked: true,
    defaultChecked: true,
  },
];

export const HRMS_PERFORMANCE_EVALAUTION_SORTING =[
  {
    id: "Newest first",
    _id: "",
    value: "",
    name: "Newest first",
  },  
  {
    _id: "user#asc",
    id: "Employee Name - Asc",
    value: "asc",
    name: "Employee Name - Asc",
  },
  {
    _id: "user#desc",
    id: "Employee Name - Desc",
    value: "desc",
    name: "Employee Name - Desc",
  },
  {
    _id: "manager#asc",
    id: "Manager Name - Asc",
    value: "asc",
    name: "Manager Name - Asc",
  },
  {
    _id: "manager#desc",
    id: "Manager Name - Desc",
    value: "desc",
    name: "Manager Name - Desc",
  },
]
